<script setup>
</script>

<template>
  <div class="-tw-mx-8 tw-border-y tw-border-grey-mid">
    <div class="tw-grid tw-grid-cols-12 tw-px-10 tw-divide-x tw-divide-grey-mid tw-min-h-12">
      <div
        class="tw-col-span-2 tw-py-2 tw-flex tw-items-center tw-cursor-pointer tw-group tw-text-grey-dark"
      >
        Element
      </div>
      <div
        class="tw-col-span-1 tw-pl-2 tw-py-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-group tw-text-grey-dark"
      >
        State
      </div>
      <div
        class="tw-col-span-4 tw-p-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-group tw-text-grey-dark"
      >
        Old Content
      </div>
      <div
        class="tw-col-span-4 tw-p-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-group tw-text-grey-dark"
      >
        New Content
      </div>
      <div class="tw-col-span-1 tw-p-2 tw-text-center tw-flex tw-items-center tw-justify-center tw-text-grey-dark" />
    </div>
  </div>
</template>

